const WHITESPACE = /\s+/g;

/**
 * The description text of a menu row wrapped as the browser last wrapped it, so the high-res render
 * breaks lines where the user saw them. Wrapping is taken from the saved `wrappingInfo` only when its
 * entry for the row is a list of lines that spell this very text; a row whose saved lines are missing,
 * malformed or describe an older text (rows added, removed or rewritten since) wraps naturally instead.
 */
export const getSavedWrapping = (wrappingInfo: string[][] | null, row: number, text: string): string => {
  const savedLines: unknown = wrappingInfo?.[row];
  if (!isListOfLines(savedLines) || !doLinesSpellText(savedLines, text)) {
    return text;
  }
  return savedLines.join('\n');
};

const isListOfLines = (value: unknown): value is string[] => {
  return Array.isArray(value) && value.every((line) => typeof line === 'string');
};

/** Wrapping only moves the breaks between words, so the lines and the text agree once whitespace is ignored. */
const doLinesSpellText = (lines: string[], text: string): boolean => {
  return lines.join('').replace(WHITESPACE, '') === text.replace(WHITESPACE, '');
};
